import { __assign } from "tslib";
import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
import initActions from './initActions';
import { ModalType } from './types';
import { pushModal } from './basicActions';
import { verifyLoggedOutAccess } from '../../redux/loggedout/actionCreators';
import { ReferralType } from '../../biLogger';
export { pushModal, popModal, removeModal, removeModalsOfType, } from './basicActions';
export var initModal = function (type, options) {
    // return init modal action if available
    var initModalAction = initActions[type];
    return initModalAction && initModalAction(options.params);
};
export var pushBadgeModal = verifyLoggedOutAccess(ReferralType.GIVE, function (badgeName, userId, title, originatingMessageId, onBadgeSent) {
    return pushModal(ModalType.GIVE_BADGE, {
        params: { badgeName: badgeName, userId: userId, title: title, originatingMessageId: originatingMessageId, onBadgeSent: onBadgeSent },
    });
});
export var pushPointsModal = verifyLoggedOutAccess(ReferralType.GIVE, function (username, title) {
    return pushModal(ModalType.GIVE_POINTS, { params: { username: username, title: title } });
});
export var pushDonateModal = verifyLoggedOutAccess(ReferralType.DONATE_POINTS, function (moduleId, username, title) {
    return pushModal(ModalType.DONATE_POINTS, {
        params: { moduleId: moduleId, username: username, title: title },
    });
});
export var pushMyGroupsModal = function (title) {
    return pushModal(ModalType.MY_GROUPS, { params: { title: title } });
};
export var pushSisuSocialModal = function (authMode, token) { return pushModal(ModalType.SISU_SOCIAL, { params: { authMode: authMode, token: token } }); };
export var pushCommentsModal = function (typeId, itemId, commentId, parentComment) {
    return pushModal(ModalType.COMMENT_THREAD, {
        params: { commentId: commentId, typeId: typeId, itemId: itemId, parentComment: parentComment },
    });
};
export var pushConfirmationModal = function (params) {
    return pushModal(ModalType.CONFIRMATION, {
        params: params,
    });
};
export var pushGlobalConfirmationModal = function (params) {
    return pushModal(ModalType.GLOBAL_CONFIRMATION, {
        params: params,
    });
};
export var pushGlobalConfirmationModalForMM = function (params) {
    return pushModal(ModalType.GLOBAL_CONFIRMATION_FOR_MM, {
        params: params,
    });
};
export var confirmYes = createAction(actionPrefix + ".CONFIRM_YES", function () { return ({}); });
export var confirmNo = createAction(actionPrefix + ".CONFIRM_NO", function () { return ({}); });
export var showMobileDeviationSharePopup = function (deviation) {
    return pushModal(ModalType.MOBILE_DEVIATION_SHARE, { params: { deviation: deviation } });
};
export var showMobileAddToGroupsPanel = verifyLoggedOutAccess(ReferralType.ADD_TO_GROUP, function (deviation) {
    return pushModal(ModalType.MOBILE_GROUPS_PANEL, { params: { deviation: deviation } });
});
export var showDeviationGroupListPopup = function (url, title) {
    return pushModal(ModalType.DEVIATION_GROUP_LIST, { params: { url: url, title: title } });
};
export var showCookieSettingsPopup = function () {
    return pushModal(ModalType.COOKIE_SETTINGS, {});
};
export var showDeviationPcpPopup = verifyLoggedOutAccess(ReferralType.PCP, function (deviation, onDownload) {
    return pushModal(ModalType.DEVIATION_PCP, { params: { deviation: deviation, onDownload: onDownload } });
});
export var showPremiumFolderPopup = verifyLoggedOutAccess(ReferralType.PREMIUM_FOLDER, function (folderId) {
    return pushModal(ModalType.PREMIUM_FOLDER, { params: { folderId: folderId } });
});
export var showOrderCommissionPopup = verifyLoggedOutAccess(ReferralType.COMMISSION, function (deviation) {
    return pushModal(ModalType.ORDER_COMMISSION, { params: { deviation: deviation } });
});
export var showSubmitModal = verifyLoggedOutAccess(ReferralType.SUBMIT, function (type, options) {
    return pushModal(type, __assign({ wrapInPopup: false }, (options || {})));
});
//# sourceMappingURL=actionCreators.js.map